import { Component, Input, OnInit } from '@angular/core';
import { GameRecord, IContextSetting } from 'diwimamodelweb/lib/network';

@Component({
  selector: 'my-btn-species',
  templateUrl: './my-btn-species.component.html',
  styleUrls: ['./my-btn-species.component.css', '../../app.component.scss']
})
export class MyBtnSpeciesComponent implements OnInit {

  @Input() species: IContextSetting
  @Input() gameRecord: GameRecord

  tableLayout: string = ""
  iconName: string|undefined = undefined
  
  constructor() { }

  ngOnInit(): void {
    if(this.gameRecord) {

      const ind = this.species.values.findIndex((el) => el.identifier == this.gameRecord.wildart)
      if (ind != -1) this.iconName = this.species.values[ind].iconName ? this.species.values[ind].iconName : ''
      this.tableLayout = `
        <table>
          <tr>
            <td>${this.gameRecord.wildart}</td>
          </tr>
          <tr>
            <td>${this.gameRecord.htmlBottomString()}</td>
          </tr>
        </table>
      `
    } else {
      this.tableLayout = `
        <div>Wildart wählen ... </div>
      `
    }
  }

}
